import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditDiascierreComponent } from "./edit-diascierre/edit-diascierre.component";

@Component({
  selector: "app-diascierre",
  templateUrl: "./diascierre.component.html",
  styleUrls: ["./diascierre.component.scss"],
})
export class DiascierreComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditDiascierreComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
